module.exports = __webpack_public_path__ + "media/assets/select_arrow-bc2d4efacb46207c4e51e3edaf4190ea.svg";